import React, { Fragment, type PropsWithChildren } from 'react';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';
import { useIsAnonymous } from '@atlassian/jira-tenant-context-controller/src/components/is-anonymous/index.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import { componentWithFG } from '@atlassian/jira-feature-gate-component/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { ProfileCardWrapper } from '../../common/ui/profilecard-wrapper/main.tsx';
import { packageName } from '../../common/constants.tsx';
import type { TeamProfileCardNextProps } from './types.tsx';
import { TeamProfileCardInner } from './main.tsx';

const ConditionalErrorBoundary = componentWithFG(
	'empanada_profilecard_sync_trigger_import_final',
	({ children }: PropsWithChildren<{}>) => (
		<JSErrorBoundary id="team-profilecard" packageName={packageName} fallback="flag">
			{children}
		</JSErrorBoundary>
	),
	Fragment,
);

const TeamProfileCardNext = (props: TeamProfileCardNextProps) => {
	const { children, teamId } = props;

	const userId = useAccountId();
	const isAnonymous = useIsAnonymous();

	const { push } = useRouterActions();

	if (!teamId || isAnonymous || !userId) {
		return <>{children}</>;
	}

	return (
		<ConditionalErrorBoundary>
			<ProfileCardWrapper>
				<TeamProfileCardInner {...props} userId={userId} onRedirect={push} />
			</ProfileCardWrapper>
		</ConditionalErrorBoundary>
	);
};

export default TeamProfileCardNext;
